import { DATE_FORMAT } from "constants"
import dayjs from "dayjs"
import { t } from "i18next"
import { localisedValue } from "utils"
import { dateTimeFunction } from "utils/date"
import { fractionizeTime } from "../utils"
import { Number } from "components/common"

const nullPlaceholder = data => (!!data ? data : "-")

const transformDetail = detail => {
  let detailArray = []

  detail?.forEach(data => {
    if (data?.type === "date")
      detailArray.push({
        label: localisedValue({ object: data, key: "title" }),
        data: nullPlaceholder(dateTimeFunction({ date: data?.response, timeZone: true, format: DATE_FORMAT })),
      })
    if (data?.type === "dropdown")
      detailArray.push({
        label: localisedValue({ object: data, key: "title" }),
        data: nullPlaceholder(data?.response?.map(item => ({ taglabel: item?.title }))),
      })
    if (data?.type === "attachment")
      detailArray.push({
        label: localisedValue({ object: data, key: "title" }),
        data: nullPlaceholder(data?.response),
        type: "attachmentComponent",
        isComponent: true,
      })
    if (data?.type === "text") {
      if (data?.key === "lead_id") {
        detailArray.push({
          label: localisedValue({ object: data, key: "title" }),
          data: nullPlaceholder(data),
          type: "linkComponent",
          isComponent: true,
        })
      } else {
        detailArray.push({
          label: localisedValue({ object: data, key: "title" }),
          data: nullPlaceholder(data?.response),
        })
      }
    }
    if (data?.type === "numeric")
      detailArray.push({
        label: localisedValue({ object: data, key: "title" }),
        data: nullPlaceholder(data?.response),
        type: "numberComponent",
        isComponent: true,
      })
  })

  return detailArray
}

const miscDetail = miscData => {
  let miscArray = []
  Object.keys(miscData || {}).forEach(key => {
    if (key === "lead") {
      miscArray.push({ label: t("Lead ID"), data: miscData?.[key]?.id })
      miscArray.push({
        label: t("Client Allocation"),
        data: localisedValue({ object: miscData?.[key]?.allocatedTo, key: "name" }),
      })
    }
    if (key === "client")
      miscArray.push({ label: t("Client Name"), data: localisedValue({ object: miscData?.[key], key: "name" }) })
    if (key === "interest")
      miscArray.push({
        label: t("Project Name"),
        data: localisedValue({ object: miscData?.[key]?.project, key: "name" }),
      })
    if (key === "contracts")
      miscArray.push(
        {
          label: t("Contract ID"),
          data: miscData?.[key]?.contractId,
        },
        {
          label: t("Unit No"),
          data: miscData?.[key]?.unitNumber,
        },
        {
          label: t("Refund Amount"),
          data: miscData?.[key]?.amount ? (
            <Number value={miscData[key]?.amount} isCurrency digitAfterFraction={2} tooltip />
          ) : null,
        }
      )
  })
  return miscArray
}

const requestWorkflowDetailTransformer = response => {
  let detail = transformDetail(response?.request?.requestData)
  let miscData = miscDetail(response?.request?.miscData)

  let requestInformation = {
    requestedBy: { object: response?.request?.requestedBy, component: true, label: t("Requested By") },
    requestedAt: {
      value: dateTimeFunction({ date: response?.request?.requestedAt, timeZone: true, format: DATE_FORMAT }),
      label: t("Requested At"),
    },
    ageing: { value: fractionizeTime(response?.request?.ageing), label: t("Total Ageing") },
  }

  let rulesList = {}
  let componentList = {}
  let dataList = {}
  let valuesList = {}
  let transformedStages = [...response?.stages]
  let currentStageIndex = response?.stages?.findIndex(item => item?.currentStage)
  const stagesList = Object.keys(response?.stages).map(item => ({
    label: response?.stages[item]?.name,
    value: response?.stages[item]?.id,
  }))

  transformedStages?.forEach((item, index) => {
    let formData = item?.formData
    let values = item?.responseData

    rulesList[index] = []
    componentList[index] = []
    dataList[index] = []
    valuesList[index] = []
    // o(n + k )
    formData.forEach(data => {
      rulesList[index].push({
        required: data?.required || false,
        message: t(`${data?.title} is required`),
      })

      componentList[index].push({
        type: data?.config?.isNumeric ? "numeric" : data?.type,
        label: data?.title,
        key: data?.key,
      })

      dataList[index].push({
        options: data?.config?.options || [],
        ...(!data?.config?.enableMultiSelect && data?.type === "dropdown" && { maxCount: 1 }),
        placeholder: t("Please Select"),
      })
    })
    valuesList[index] = {}
    values?.forEach(data => {
      if (data?.type === "date") {
        valuesList[index][data.key] = {
          ...data,
          response: dayjs(data?.response),
        }
      } else if (data?.type === "dropdown") {
        valuesList[index][data?.key] = { ...data, response: data?.response?.map(item => item?.optionKey) }
      } else {
        valuesList[index][data?.key] = { ...data }
      }
      return valuesList
    })
  })

  return {
    ...response,
    detail,
    requestInformation,
    rulesList,
    componentList,
    dataList,
    transformedStages,
    currentStageIndex,
    stagesList,
    valuesList,
    miscData,
  }
}

export default requestWorkflowDetailTransformer
